import React from 'react';
import { View, StyleSheet } from 'react-native';
import Skeleton from '../common/Skeleton';

const FeedPostSkeleton: React.FC = () => {
  return (
    <View style={styles.container}>
      {/* Header - User info */}
      <View style={styles.header}>
        <Skeleton width={40} height={40} borderRadius={20} />
        <View style={styles.headerText}>
          <Skeleton width={120} height={16} borderRadius={4} />
          <Skeleton width={80} height={12} borderRadius={4} style={{ marginTop: 4 }} />
        </View>
      </View>

      {/* Post content */}
      <View style={styles.content}>
        <Skeleton width="100%" height={14} borderRadius={4} />
        <Skeleton width="90%" height={14} borderRadius={4} style={{ marginTop: 8 }} />
        <Skeleton width="75%" height={14} borderRadius={4} style={{ marginTop: 8 }} />
      </View>

      {/* Image placeholder (optional) */}
      <Skeleton width="100%" height={200} borderRadius={12} style={{ marginTop: 12 }} />

      {/* Actions */}
      <View style={styles.actions}>
        <Skeleton width={60} height={20} borderRadius={4} />
        <Skeleton width={60} height={20} borderRadius={4} />
        <Skeleton width={60} height={20} borderRadius={4} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 16,
    paddingHorizontal: 16,
    marginBottom: 24,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  headerText: {
    marginLeft: 12,
    flex: 1,
  },
  content: {
    marginTop: 8,
  },
  actions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 16,
    paddingHorizontal: 16,
  },
});

export default FeedPostSkeleton;
